//
export default [
    {
        field: 'alias_name',
        value: '',
        label: 'Alias',
    },
    {
        field: 'wh_family_id',
        value: [],
        label: 'Familia',
        options: [],
    },
    {
        field: 'wh_subfamily_id',
        value: [],
        label: 'Subfamilia',
        options: [],
    },
]
